import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Align, Direction, GuiLayout} from "@nolimitcity/slot-launcher/bin/gui/utils/GuiLayout";
import {GuiDefaults} from "@nolimitcity/slot-launcher/bin/gui/default/GuiDefaults";
import {TweenLite} from "gsap";

export class BookOfShadowsSlideShowPage extends SlideShowPage {
    private _animation: TimelineSprite;

    /**
     * @constructs
     * @param textures
     * @param fps
     * @param textString1
     * @param textString2
     * @param subTexture
     */
    constructor(textures: PIXI.Texture[], fps: number = 30, textString1?: string, textString2?: string, subTexture?: PIXI.Texture) {
        if (!textString2 && !subTexture) {
            super(undefined, textString1);
        } else {
            super(undefined, undefined);
        }

        this.createAnimationItem(textures, fps);
        if (textString1 && textString2 && subTexture) {
            this.createRightPanel(textString1, textString2, subTexture);
        }
    }

    /**
     * @inheritDoc
     * @override To start the animation.
     * @param enable
     */
    public enable(enable: boolean): void {
        super.enable(enable);
        let delay: number;

        if (enable) {
            delay = ((this._animation.totalFrames > 15) ? 2 : 3);
            this._animation.getAnimation();
            TweenLite.delayedCall((this._animation.totalDuration + delay), () => this._animation.getAnimation());
        } else {
            this._animation.setFrame(0);
        }
    }

    /**
     * @description To create the animation item.
     * @param textures
     * @param fps
     */
    private createAnimationItem(textures: PIXI.Texture[], fps: number): void {
        const animation = new TimelineSprite(textures, fps);
        animation.anchor.set(1, 0.5);
        animation.position.x = -10;
        this.addChild(animation);

        this._animation = animation;
    }

    /**
     * @description To create the right panel.
     * @param textString1
     * @param textString2
     * @param subTexture
     */
    private createRightPanel(textString1: string, textString2: string, subTexture: PIXI.Texture): void {
        const panel: PIXI.Container = new PIXI.Container(),
            text1: PIXI.Text = new PIXI.Text(textString1, GuiDefaults.INTRO_PAGE_TEXT),
            text2: PIXI.Text = new PIXI.Text(textString2, GuiDefaults.INTRO_PAGE_TEXT),
            subImage: PIXI.Sprite = new PIXI.Sprite(subTexture);

        panel.pivot.set(panel.width * 0.5, panel.height * 0.5);
        panel.addChild(text1, subImage, text2);

        GuiLayout.align([text1, subImage, text2], 10, Align.CENTER, Direction.VERTICAL);

        // #262
        text1.x = 10;

        panel.y = -(panel.height * 0.5);
        text2.x = text1.x;

        this.addChild(panel);
    }
}